module.exports = __webpack_public_path__ + "static/media/04-kor.99978458.png";